import { render, staticRenderFns } from "./ChangeAnswerEffect.vue?vue&type=template&id=5844ec62&scoped=true&"
import script from "./ChangeAnswerEffect.vue?vue&type=script&lang=js&"
export * from "./ChangeAnswerEffect.vue?vue&type=script&lang=js&"
import style0 from "./ChangeAnswerEffect.vue?vue&type=style&index=0&id=5844ec62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5844ec62",
  null
  
)

export default component.exports